import { useSelector, useDispatch } from 'react-redux';
import { setUser, initialState } from '../../store/auth/userSlice';
import { apiGetCustomerDetail } from '../../services/AuthService';
import {
  onSignInSuccess,
  onSignOutSuccess,
} from '../../store/auth/sessionSlice';
import { useNavigate } from 'react-router-dom';

function useAuth() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { token, signedIn } = useSelector((state) => state.auth.session);
  const { email, fullname } = useSelector((state) => state.auth.user);

  const signIn = async (token) => {
    return new Promise((res) => {
      setTimeout(async () => {
        try {
          const customerDetail = await apiGetCustomerDetail(token);
          if (customerDetail) {
            const userData =
              customerDetail.data?.data ||
              customerDetail.data ||
              customerDetail;
            dispatch(
              setUser({
                fullname: userData.fullname || '',
                phone: userData.phone || '',
                email: userData.email || '',
                id: userData.id || '',
                favoritestores: userData.favoritestores || [],
              })
            );
            dispatch(onSignInSuccess(token));
            res(true);
          } else {
            res(false);
          }
        } catch (error) {
          // If the detail fetch fails the outer promise would otherwise
          // hang forever — resolve to false so the UI can recover.
          console.error('signIn failed to fetch customer detail:', error);
          res(false);
        }
      }, 750);
    });
  };

  const handleSignOut = () => {
    dispatch(onSignOutSuccess());
    dispatch(setUser(initialState));
    navigate('/');
  };

  const signOut = async () => {
    handleSignOut();
  };

  return {
    authenticated: token && signedIn,
    needComplete:
      email === null || email === '' || fullname === null || fullname === '',
    signIn,
    signOut,
  };
}

export default useAuth;
